var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-with-header-layout',{attrs:{"title":_vm.t('conference.roomConferences'),"items":_vm.items,"fields":_vm.fields,"new-button":{ name: 'Conference-Room-Booking' },"th-color-class":"bg-primary text-white"}})}
var staticRenderFns = []

export { render, staticRenderFns }